// Tooltip/label wording for the property override indicator.
//
// The *determination* of explicit-vs-inherited stays where it already lives
// (node.hasExplicitStyle(), see StyleResolver.js) — this module only turns that
// boolean pair into the words the icon needs, so the phrasing has one home and
// can be unit-tested without a DOM.
//
// `inherited` means "the fallback beneath this value comes from another scope
// the user can see" (a non-default state falling back to the part's default
// state), as opposed to the schema/theme default.
export function overrideStatusTitle(overridden, inherited) {
  if (overridden) return inherited ? 'Reset to inherited value' : 'Reset to default';
  return inherited ? 'Inherited' : 'Using default value';
}
